export enum TasksTab {
  AllTasks = 'allTasks',
  MyTasks = 'myTasks',
  GroupTasks = 'groupTasks',
  AssignedTasks = 'assignedTasks',
}

export enum TaskType {
  Individual = 'Individual',
  Group = 'Group',
}

export enum SubtaskStatus {
  Incomplete = 0,
  Complete = 1,
}

export enum TaskStatus {
  ToDo = 'ToDo',
  InProgress = 'InProgress',
  Completed = 'Completed',
}

export enum TaskProgressStatus {
  ToDo = 0,
  Completed = 1,
}
